import AppContainer from './App.container';
import App from './App';

export default AppContainer(App);
